Ext.define('SA.controller.MenuController', {
    extend: 'Ext.app.Controller',

    init() {
        this.control({
            'menu': {
                beforeshow: this.beforeMenuShow
            }
        });
    },

    beforeMenuShow(menu) {
        menu.query('> [beforeMenuShow]').forEach(item => {
            item.beforeMenuShow();
        });
    }
});